<template>
    <div class="">
        <ul class="progress__bar list list--horizontal d-flex align-items-center" >
            <li v-if="!((id == Object.keys(steps).length) && !hasLastStep) && (!noUploadStep || (noUploadStep && (id !== '2')))" class="progress__item list__item list__item--horizontal" v-for="(step, id) in steps">
                <router-link
                        v-if="step.completed && hasActiveItem() && !((id == Object.keys(steps).length) && hasLastStep)"
                        class="progress__link progress__link--completed"
                        :to="{ name: step.route, params: { document: documentSlug() }}">
                    {{ id }}
                </router-link>
                <span v-if="(!step.completed && hasActiveItem()) || !hasActiveItem()"
                        class="progress__link"
                        v-bind:class="{ 'progress__link--active': step.active && hasActiveItem() }">

                    <span v-if="noUploadStep && (id !== '2')">{{ id -1 }}</span>
                    <span v-else>{{ id }}</span>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'ProgressBar',
        data: function () {
            return {
                steps: this.$StepHelper.getSteps(this.noUploadStep)
            }
        },
        props: {
            hasLastStep: Boolean,
            noUploadStep: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            // set the active step
            '$route': function(to, from) {
                this.$StepHelper.setActive(to);
            }
        },
        methods: {
            documentSlug() {
                return this.$StepHelper.getDocumentSlug()
            },
            hasActiveItem() {
                let foundActive = false;

                _.each(this.steps,function(elem,key){
                    if(elem.active) {
                        foundActive = true;
                    }
                });

                return foundActive;
            }
        },
        created() {
            this.$StepHelper.setActive(this.$router.currentRoute)
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/components/ProgressBar.vue